import Vue from 'vue';
import VueResource from 'vue-resource';
import VueResourceCaseConverter from '@/lib/vue-resource-case-converter';
import config from '@/config';

Vue.use(VueResource);
Vue.use(VueResourceCaseConverter, {
  responseUrlFilter() {
    return {
      convert: false
    };
  }
});

const Resource = Vue.resource;
const HTTP = Vue.http;

function buildURL(host, path) {
  return `${host}/${path}`;
}

function HostResource(host) {
  return function resourceWithHost(path, ...args) {
    const URL = buildURL(host, path);
    return Resource(URL, ...args);
  };
}

const MainAppResource = HostResource(config.API_URL);
const AuthServiceResource = HostResource(config.AUTH_URL);

export { HTTP, Resource, MainAppResource, AuthServiceResource };
export default Resource;
